import { render, staticRenderFns } from "./NameStep.vue?vue&type=template&id=f16d21f0&scoped=true&"
import script from "./NameStep.vue?vue&type=script&lang=js&"
export * from "./NameStep.vue?vue&type=script&lang=js&"
import style0 from "./NameStep.vue?vue&type=style&index=0&id=f16d21f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16d21f0",
  null
  
)

export default component.exports